module.exports = __webpack_public_path__ + "static/media/varais-3.ad37c6ea.jpg";